
import firebase from '@/firebase'

// State object
const state = {
  tasks: [],
}
// Getter functions
const getters = {
  orderedTasks: state => {
    return state.tasks.sort((a,b)=>{ return a.index>b.index?1:-1; });
  }
}
// Actions
const actions = {
  queryTasks({state,commit,rootState}) {
    console.log('queryTasks')

    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const tasksRef = db.collection('users').doc(rootState.user.uid).collection('tasks');
    return tasksRef.get().then(snapshot => {
      console.log('queryTasks ok')
      let arr = [];
      var index = 1;
      snapshot.forEach(register => {
        let task = { id:register.id, ...register.data() };
        if(!task.index) task.index = index++;
        arr.push(task);
      });
      commit('setTasks',arr);
    });

  },
  changeTaskOrder({state,commit,rootState},{task_id,index}){
    state.tasks.forEach((task)=>{
      if(task.id==task_id) task.index = index;
      return task;
    })
    this.dispatch('reorderTasks');
  },
  reorderTasks({state,commit,rootState}){
    const db = firebase.firestore();
    const tasksRef = db.collection('users').doc(rootState.user.uid).collection('tasks');
    let batch = db.batch();

    var tasks = this.getters.orderedTasks;
    var index=1;
    tasks.forEach(task => {
      task.index = index++;
      let taskRef = tasksRef.doc(task.id);
      batch.update(taskRef, {index:task.index });
    });

    batch.commit().then(function () {
      console.log('Salvou nova ordem');
    });

  },


  checkTasksOverdue({state,commit,rootState}){
    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const tasksRef = db.collection('users').doc(rootState.user.uid).collection('tasks');
    var overdue = false;
    state.tasks.forEach(task=>{
      if(task.due){
        var dateDue = new Date(task.due);
        overdue = dateDue < new Date();
      }
      if(overdue != task.overdue){
        task.overdue = overdue;
        tasksRef.doc(task.id).update({overdue:overdue})
      }
      return task;
    });

  },

  updateTask({state,commit,rootState},{task_id,data}){
    console.log(task_id,'task_id')
    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const tasksRef = db.collection('users').doc(rootState.user.uid).collection('tasks');

    state.tasks.forEach(task=>{
      if(task.id == task_id) {
        for (let field in data){
          task[field] = data[field];
        }
        if(task.due){
          var dateDue = new Date(task.due);
          task.overdue = dateDue < new Date();
          data['overdue'] = task.overdue;
        }

      }
      return task;
    });

    return tasksRef.doc(task_id).update(data).then(()=>{
      console.log("updatetask OK");
      this.dispatch('queryTasks');
    }).catch(function(error) {
      console.error("Error updating document: ", error);
    });

  },

  addTask({state,commit,rootState},{data}){
    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const tasksRef = db.collection('users').doc(rootState.user.uid).collection('tasks');

    var tmp_id = new Date().getTime();
    if(data.due){
      var dateDue = new Date(data.due);
      data.overdue = dateDue < new Date();
    }
    state.tasks.push({id:tmp_id,...data});

    return tasksRef.add(data).then(()=>{
      console.log("addtask OK");
      this.dispatch('queryTasks');
    }).catch(function(error) {
      console.error("Error updating document: ", error);
    });

  },

  deleteTask({state,commit,rootState},{task_id}){

    if(!rootState.user.uid) return;
    const db = firebase.firestore();
    const tasksRef = db.collection('users').doc(rootState.user.uid).collection('tasks');

    var indexDelete = null;
    state.tasks.forEach((task,index)=>{
      if(task.id == task_id) {
        indexDelete = index;
      }
      return task;
    });
    state.tasks.splice(indexDelete,1);

    return tasksRef.doc(task_id).delete().then(()=>{
      console.log("deletetask OK");
      this.dispatch('queryTasks');
    }).catch(function(error) {
      console.error("Error updating document: ", error);
    });

  },

}
// Mutations
const mutations = {
  setTasks(state, data) {
    state.tasks = data;
  },
}
export default {
  //namespaced: true,
  state,
  getters,
  actions,
  mutations
}